import { render, staticRenderFns } from "./CandidateOrEmployerTemplateProfile.vue?vue&type=template&id=29d17960&scoped=true&lang=pug"
import script from "./CandidateOrEmployerTemplateProfile.vue?vue&type=script&lang=ts"
export * from "./CandidateOrEmployerTemplateProfile.vue?vue&type=script&lang=ts"
import style0 from "./CandidateOrEmployerTemplateProfile.vue?vue&type=style&index=0&id=29d17960&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d17960",
  null
  
)

export default component.exports